// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.inputCheckboxLabel {
  font-family: "Omnes-ATT-W02", Arial;
  font-size: 14px;
}

.tooltipActive + .helper-text {
  display: block;
  text-align: center !important;
  width: 1560%;
  margin-bottom: 0px !important;
  bottom: 100%;
  margin-left: -220px;
}
@media (max-width: 1024px) {
  .tooltipActive + .helper-text {
    width: 120px !important;
    margin-left: -64px;
    height: 260px;
  }
}
@media (max-width: 1024px) {
  .tooltipActive + .helper-text {
    width: 700% !important;
    margin-left: -75px;
  }
}

.tooltip-input {
  right: -685px;
  bottom: -5px;
  width: 30px;
}
@media (max-width: 1024px) {
  .tooltip-input {
    right: -190px;
    bottom: -5px;
    width: 20px;
  }
}
@media (max-width: 980px) and (min-width: 400px) {
  .tooltip-input {
    right: -190px;
    bottom: -5px;
    width: 20px;
  }
}
@media screen and (min-device-width: 375px) and (max-device-width: 667px) {
  .tooltip-input {
    right: -170px !important;
    bottom: -5px;
    width: 20px;
  }
}
@media screen and (min-device-width: 414px) and (max-device-width: 736px) {
  .tooltip-input {
    right: -190px !important;
    bottom: -5px;
    width: 20px;
  }
}
@media (max-width: 1024px) {
  .tooltip-input {
    right: -200px;
    bottom: -5px;
    width: 20px;
  }
}

.mediaStop {
  height: 140px;
  width: 251px;
  margin-bottom: 20px;
}

.accordion {
  border-bottom: 1px solid #c4c4c4;
  margin-bottom: 60px;
}

.tab-nav {
  width: max-content;
}

.legalAgreement {
  display: flexbox;
  top: 1189px;
  left: 215px;
  width: 951px;
  height: 150px;
  background: #F2F2F2 0% 0% no-repeat padding-box;
  opacity: 1;
  font-size: 16px !important;
  padding: 15px 15px 15px 15px;
}
.legalAgreement h3 {
  margin: 0px !important;
  font-size: 24px !important;
}
.legalAgreement p {
  margin: 0px !important;
}
@media (max-width: 1024px) {
  .legalAgreement p {
    margin-left: -5px !important;
    width: 265px !important;
  }
}
@media (max-width: 1024px) {
  .legalAgreement {
    width: 325px !important;
    height: 275px;
    margin-left: -80px;
  }
}
@media only screen and (max-width: 590px) and (min-width: 420px) {
  .legalAgreement {
    width: 360px;
  }
}
@media only screen and (max-width: 1320px) and (min-width: 600px) {
  .legalAgreement {
    width: 800px;
  }
}

.notifications-section {
  margin-top: 15px;
}
@media (max-width: 1024px) {
  .notifications-section {
    margin-left: -15px;
    width: 225px;
  }
}
@media (max-width: 1024px) {
  .notifications-section p {
    margin-left: -65px !important;
    width: 265px;
  }
}

.notifications-heading {
  font-size: 32px;
}
@media (max-width: 1024px) {
  .notifications-heading {
    font-size: 27px;
  }
}

.notifications-label {
  width: 100%;
}

#notification-email-label {
  margin-bottom: 15px;
  margin-left: 5px;
}
@media (max-width: 1024px) {
  #notification-email-label {
    margin-left: -60px;
  }
}

#notification-text-label {
  margin-left: 5px;
}
@media (max-width: 1024px) {
  #notification-text-label {
    margin-left: -60px;
  }
}

@media only screen and (min-width: 1024px) and (max-width: 1220px) {
  .tab-nav .app-tab .list a {
    font-size: 1.5rem;
  }
}
@media only screen and (min-width: 1221px) and (max-width: 1250px) {
  .tab-nav .app-tab .list a {
    font-size: 1.8rem;
  }
}
@media only screen and (min-width: 1251px) and (max-width: 1273px) {
  .tab-nav .app-tab .list a {
    font-size: 1.9rem;
  }
}
.accounts-tab {
  margin: 0 10%;
}
@media (max-width: 1024px) {
  .accounts-tab .pull-right {
    float: right;
    width: 280px;
    margin-right: -60px;
  }
}
@media screen and (min-device-width: 375px) and (max-device-width: 667px) {
  .accounts-tab .pull-right {
    margin-right: -60px;
  }
}
@media screen and (min-device-width: 414px) and (max-device-width: 736px) {
  .accounts-tab .pull-right {
    margin-right: -30px;
  }
}
.accounts-tab .btn-link {
  padding-top: 10px;
}
@media (max-width: 1024px) {
  .accounts-tab .btn-link {
    margin-right: 60px;
  }
}
@media (max-width: 1024px) {
  .accounts-tab .text-right {
    text-align: center;
  }
}
@media (max-width: 1024px) {
  .accounts-tab h2 {
    margin-left: -75px;
  }
}
@media (max-width: 1024px) {
  .accounts-tab p {
    margin-left: -75px;
    width: 320px;
  }
}
@media (max-width: 1024px) {
  .accounts-tab .main-wrapper {
    margin-left: -40px !important;
  }
}
.accounts-tab h3 {
  font: 24px "Omnes-ATT-W02";
  margin-top: 30px;
  margin-bottom: 30px;
}
@media (max-width: 1024px) {
  .accounts-tab h3 {
    font: 16px "Omnes-ATT-W02-Medium";
  }
}
.accounts-tab .icon-arrows-sort-arrow {
  font-size: 17px !important;
}
.accounts-tab .search {
  position: relative;
}
.accounts-tab .search input {
  padding-right: 40px;
}
.accounts-tab .search .search-icon {
  cursor: pointer;
  margin-top: -10px;
  position: absolute;
  right: 20px;
  top: 50%;
}
.accounts-tab .search .search-icon .icon-controls-magnifyingglass {
  color: #c4c4c4;
  font-size: 25px;
  font-weight: bold;
  margin-right: 3px;
  margin-top: -2px;
}
.accounts-tab .search .search-icon .icon-close {
  color: #c4c4c4;
  font-size: 25px;
  font-weight: bold;
  margin-right: 3px;
  margin-top: -2px;
}
.accounts-tab .search #searchField::-ms-clear {
  display: none;
}
.accounts-tab .search-label {
  display: none;
}
.accounts-tab .rowdisabled {
  pointer-events: none;
}
.accounts-tab .box-outer {
  padding: 0 30px;
}
.accounts-tab .tab-content {
  padding: 0;
}
.accounts-tab .tab-content h2 {
  font-size: 3rem;
  font-weight: normal;
  margin: 30px 0;
}
.accounts-tab .tab-content p {
  margin-bottom: 20px;
}
.accounts-tab .acc-content table {
  margin: 0;
}
.accounts-tab .acc-content table tbody:last-child td {
  border-bottom: 0 !important;
}
.accounts-tab tr th:first-child {
  width: 15%;
}
.accounts-tab .accounts {
  margin-bottom: 30px;
}
.accounts-tab .buttons-section {
  padding: 30px 0;
}
.accounts-tab .check {
  margin-bottom: 30px;
}
.accounts-tab .check .checkbox {
  display: block;
}
.accounts-tab .error-text {
  color: hsl(0, 66%, 49%);
}
.accounts-tab .error-text .skin {
  border: 1px solid hsl(0, 66%, 49%);
}
.accounts-tab .modal-header {
  margin-bottom: 10px;
}
.accounts-tab .terms-and-conditions .checkbox a {
  color: #191919;
}
.accounts-tab .terms-and-conditions .row {
  margin-left: 0;
  margin-right: 0;
}
.accounts-tab .terms-and-conditions .form-group {
  margin-left: 0;
  margin-right: 0;
}
.accounts-tab .terms-and-conditions .terms h1 {
  margin-top: 30px;
}
.accounts-tab .agreement {
  margin-top: 15px;
}
.accounts-tab .agreement h2 {
  font-size: 20px;
}
.accounts-tab .agreement .attTerms {
  padding-bottom: 10px;
}
.accounts-tab .agreement p {
  margin-bottom: 0;
  display: inline;
}
.accounts-tab .agreement .termsServiceText p {
  margin-bottom: 0;
  display: inline;
}
.accounts-tab .signupwithnotab .agreement {
  border-top: 1px solid #d2d2d2;
  margin-top: 30px;
}
.accounts-tab .signupwithnotab .agreement h3 {
  margin-bottom: 20px;
}
.accounts-tab .signuptabcontainer {
  position: relative;
}
.accounts-tab .signuptabcontainer .pagination::after {
  border: 0 none;
  height: 0;
  width: 0;
}
.accounts-tab .alert {
  margin-bottom: 30px;
}
.accounts-tab .fan-profile {
  cursor: pointer;
}
.accounts-tab .terms-of-service-container {
  border-top: 1px solid #d2d2d2;
}
.accounts-tab .terms-of-service-container .checkbox:first-child {
  margin-bottom: 20px;
}
.accounts-tab .ineligible-fans {
  color: hsl(0, 66%, 49%);
}
.accounts-tab .attTerms,
.accounts-tab .ibmTerms {
  margin-bottom: 20px;
  font-size: 16px;
  font-family: Omnes-ATT-W02, Arial;
}
@media (max-width: 1024px) {
  .accounts-tab {
    margin: 0 80px;
  }
  .accounts-tab .accordion {
    margin-bottom: 30px;
  }
  .accounts-tab .tab-nav {
    width: unset;
  }
  .accounts-tab .signup-section .tabContainer {
    height: max-content;
  }
  .accounts-tab .btn-cancel {
    text-align: center;
  }
}
@media (max-width: 1024px) and (max-width: 1024px) {
  .accounts-tab .btn-cancel {
    margin-left: 25px !important;
  }
}
@media (max-width: 1024px) {
  .accounts-tab .btn {
    text-align: center;
  }
}
@media (max-width: 1024px) {
  .accounts-tab .tab-nav .app-tab .list > a {
    padding: 25px 1px !important;
    color: #191919 !important;
  }
  .accounts-tab .tab-content h2,
  .accounts-tab .tab-content p {
    margin-bottom: 20px !important;
  }
  .accounts-tab .accounts,
  .accounts-tab .check {
    margin-bottom: 20px;
  }
  .accounts-tab .form-group {
    margin-bottom: 20px;
  }
  .accounts-tab .agreement p {
    margin-bottom: 0 !important;
  }
  .accounts-tab .grid-table {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media (max-width: 1024px) and (max-width: 1024px) {
  .accounts-tab .grid-table {
    margin-left: -100px;
    margin-right: -39px;
  }
}
@media (max-width: 1024px) {
  .accounts-tab .step-indicator,
  .accounts-tab .alert {
    margin-bottom: 30px !important;
  }
}
.accounts-tab .search-field {
  float: right;
}
.accounts-tab .link-to-brief {
  margin: 20px 0;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/signup-setup/enrollmentpoc/enrollmentpoc.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACI,mCAAA;EACE,eAAA;AAmJN;;AA1IA;EACI,cAAA;EACA,6BAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,mBAAA;AA6IJ;AFxII;EEXJ;IAQQ,uBAAA;IACA,kBAAA;IACA,aAAA;EA+IN;AACF;AA7II;EAbJ;IAcQ,sBAAA;IACA,kBAAA;EAgJN;AACF;;AA7IA;EACI,aAAA;EACA,YAAA;EACA,WAAA;AAgJJ;AF3JI;EEQJ;IAMQ,aAAA;IACA,YAAA;IACA,WAAA;EAiJN;AACF;AAhJI;EAVJ;IAWQ,aAAA;IACA,YAAA;IACA,WAAA;EAmJN;AACF;AAlJI;EAfJ;IAgBQ,wBAAA;IACA,YAAA;IACA,WAAA;EAqJN;AACF;AApJM;EApBN;IAqBQ,wBAAA;IACA,YAAA;IACA,WAAA;EAuJN;AACF;AAtJM;EAzBN;IA0BQ,aAAA;IACA,YAAA;IACA,WAAA;EAyJN;AACF;;AArJA;EACI,aAAA;EACA,YAAA;EACA,mBAAA;AAwJJ;;AAtJA;EACQ,gCAAA;EACA,mBAAA;AAyJR;;AAtJA;EAEI,kBAAA;AAwJJ;;AArJA;EACI,gBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,+CAAA;EACA,UAAA;EAEA,0BAAA;EACA,4BAAA;AAuJJ;AAtJI;EACI,sBAAA;EACA,0BAAA;AAwJR;AArJI;EACI,sBAAA;AAuJR;AFhOI;EEwEA;IAGQ,4BAAA;IACA,uBAAA;EAyJV;AACF;AFtOI;EEwDJ;IAyBQ,uBAAA;IACA,aAAA;IACA,kBAAA;EAyJN;AACF;AAxJM;EA7BN;IA+Be,YAAA;EA0Jb;AACF;AAzJO;EAjCP;IAmCc,YAAA;EA2JZ;AACF;;AAxJA;EACI,gBAAA;AA2JJ;AF3PI;EE+FJ;IAGO,kBAAA;IACA,YAAA;EA6JL;AACF;AFjQI;EEqGA;IAEI,6BAAA;IACA,YAAA;EA8JN;AACF;;AA1JA;EACI,eAAA;AA6JJ;AA5JI;EAFJ;IAGQ,eAAA;EA+JN;AACF;;AA5JA;EACI,WAAA;AA+JJ;;AA5JA;EACI,mBAAA;EACA,gBAAA;AA+JJ;AFzRI;EEwHJ;IAIQ,kBAAA;EAiKN;AACF;;AA/JA;EACI,gBAAA;AAkKJ;AFlSI;EE+HJ;IAGQ,kBAAA;EAoKN;AACF;;AAjKA;EAIU;IACE,iBAAA;EAiKV;AACF;AA5JA;EAIQ;IACE,iBAAA;EA2JR;AACF;AAtJA;EAIQ;IACE,iBAAA;EAqJR;AACF;AA5IA;EACI,aAAA;AA8IJ;AF1TI;EE6KA;IAEI,YAAA;IACA,YAAA;IACA,mBAAA;EA+IN;AACF;AA9IQ;EANJ;IAOK,mBAAA;EAiJP;AACF;AAhJO;EATH;IAUI,mBAAA;EAmJN;AACF;AAjJI;EACI,iBAAA;AAmJR;AF9UI;EE0LA;IAGM,kBAAA;EAqJR;AACF;AFnVI;EEgMA;IAEI,kBAAA;EAqJN;AACF;AFxVI;EE+MJ;IAEQ,kBAAA;EA2IN;AACF;AF7VI;EEoNJ;IAEI,kBAAA;IACA,YAAA;EA2IF;AACF;AFnWI;EE0NJ;IAEQ,6BAAA;EA2IN;AACF;AAxIE;EACE,0BAAA;EACA,gBAAA;EACA,mBAAA;AA0IJ;AF7WI;EEgOF;IAKI,iCAAA;EA4IJ;AACF;AA1IE;EACM,0BAAA;AA4IR;AA1II;EACI,kBAAA;AA4IR;AA3IQ;EACI,mBAAA;AA6IZ;AA3IQ;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AA6IZ;AA5IY;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AA8IhB;AA5IY;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AA8IhB;AA3II;EACE,aAAA;AA6IN;AAzIE;EACE,aAAA;AA2IJ;AAxII;EACI,oBAAA;AA0IR;AAxII;EACI,eAAA;AA0IR;AAxII;EACI,UAAA;AA0IR;AAzIQ;EACI,eAAA;EACA,mBAAA;EACA,cAAA;AA2IZ;AAzIQ;EACI,mBAAA;AA2IZ;AAvIQ;EACI,SAAA;AAyIZ;AAxIY;EACI,2BAAA;AA0IhB;AApIY;EACI,UAAA;AAsIhB;AAlII;EACI,mBAAA;AAoIR;AAlII;EAGI,eAAA;AAkIR;AAhII;EACI,mBAAA;AAkIR;AAjIQ;EACI,cAAA;AAmIZ;AAhII;EACI,uBAAA;AAkIR;AAjIQ;EACI,kCAAA;AAmIZ;AAhII;EACI,mBAAA;AAkIR;AA9HY;EACI,cAAA;AAgIhB;AA7HQ;EACI,cAAA;EACA,eAAA;AA+HZ;AA7HQ;EACI,cAAA;EACA,eAAA;AA+HZ;AA5HY;EACI,gBAAA;AA8HhB;AA1HI;EAEI,gBAAA;AA2HR;AA1HQ;EACI,eAAA;AA4HZ;AA1HU;EACE,oBAAA;AA4HZ;AAvHQ;EACI,gBAAA;EACA,eAAA;AAyHZ;AAtHY;EACI,gBAAA;EACA,eAAA;AAwHhB;AAnHQ;EACI,6BAAA;EACA,gBAAA;AAqHZ;AApHY;EACI,mBAAA;AAsHhB;AAlHI;EACI,kBAAA;AAoHR;AAlHY;EACI,cAAA;EACA,SAAA;EACA,QAAA;AAoHhB;AAhHI;EACI,mBAAA;AAkHR;AAhHI;EACI,eAAA;AAkHR;AAhHI;EACI,6BAAA;AAkHR;AAhHY;EACI,mBAAA;AAkHhB;AA9GI;EACI,uBAAA;AAgHR;AA9GI;;EAEI,mBAAA;EACA,eAAA;EACA,iCAAA;AAgHR;AFxgBI;EE2KJ;IAgPQ,cAAA;EAiHN;EA/GE;IACI,mBAAA;EAiHN;EA/GC;IACE,YAAA;EAiHH;EA9GI;IACE,mBAAA;EAgHN;EA5GM;IAEI,kBAAA;EA6GV;AACF;AFzhBI;EEyaI;IAKQ,4BAAA;EA+Gd;AACF;AF9hBI;EEkbI;IACI,kBAAA;EA+GV;AACF;AFniBI;EE4bY;IACI,4BAAA;IACA,yBAAA;EA0GlB;EArGU;;IAEI,8BAAA;EAuGd;EApGM;;IAEI,mBAAA;EAsGV;EApGM;IACI,mBAAA;EAsGV;EAnGU;IACI,2BAAA;EAqGd;EAlGM;IACI,kBAAA;IACA,mBAAA;EAoGV;AACF;AF3jBI;EEodI;IAII,mBAAA;IACA,mBAAA;EAuGV;AACF;AFjkBI;EE4dI;;IAEI,8BAAA;EAwGV;AACF;AAtGI;EACI,YAAA;AAwGR;AArGI;EACI,cAAA;AAuGR","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.inputCheckboxLabel{\n    font-family: 'Omnes-ATT-W02', Arial;\n      font-size: 14px;\n  }\n  \n.acc-content {\n    // padding-bottom: 5px;\n    // // padding-left: 20px;\n    // margin-bottom: 8px;\n}\n\n.tooltipActive + .helper-text {\n    display: block;\n    text-align: center !important;\n    width: 1560%;\n    margin-bottom: 0px !important;\n    bottom: 100%;\n    margin-left: -220px;\n    @include respond-to('small') {\n        width: 120px !important;\n        margin-left: -64px;\n        height: 260px;\n    }\n\n    @media(max-width: 1024px) {\n        width: 700% !important;\n        margin-left: -75px;\n    }\n}\n\n.tooltip-input {\n    right: -685px;\n    bottom: -5px;\n    width: 30px;\n\n    @include respond-to('small') {\n        right: -190px;\n        bottom: -5px;\n        width: 20px;\n    }\n    @media(max-width: 980px) and (min-width:400px) {\n        right: -190px ;\n        bottom: -5px;\n        width: 20px;\n    }\n    @media screen and (min-device-width : 375px) and (max-device-width : 667px) {\n        right: -170px !important;\n        bottom: -5px;\n        width: 20px;\n      }\n      @media screen and (min-device-width : 414px) and (max-device-width : 736px) {\n        right: -190px !important;\n        bottom: -5px;\n        width: 20px;\n      }\n      @media(max-width: 1024px) {\n        right: -200px ;\n        bottom: -5px;\n        width: 20px;\n      }\n     \n}\n\n.mediaStop{\n    height:140px;\n    width:251px;\n    margin-bottom: 20px;\n    }\n.accordion {\n        border-bottom: 1px solid color(default, darker);\n        margin-bottom: 60px;\n    }\n\n.tab-nav {\n    \n    width: max-content ;\n  }\n\n.legalAgreement {\n    display: flexbox;\n    top: 1189px;\n    left: 215px;\n    width: 951px ;\n    height: 150px;\n    background: #F2F2F2 0% 0% no-repeat padding-box;\n    opacity: 1;\n    //padding: 25px;\n    font-size: 16px !important;\n    padding: 15px 15px 15px 15px;\n    h3 {\n        margin: 0px  !important;\n        font-size: 24px !important;\n    }\n\n    p {\n        margin: 0px !important;\n        @include respond-to ('small') {\n            margin-left: -5px !important;\n            width: 265px !important;\n        }\n    }\n\n    @include respond-to ('small') {\n        width: 325px !important ;\n        height: 275px;\n        margin-left: -80px;\n    }\n      @media only screen and\n           (max-width: 590px) and (min-width:420px) {\n               width: 360px ;\n        }\n       @media only screen and\n          (max-width: 1320px) and (min-width:600px) {\n              width: 800px ;\n       }\n}\n\n.notifications-section {\n    margin-top: 15px;\n    @include respond-to ('small') {\n       margin-left: -15px;\n       width: 225px;\n    }\n    p{\n        @include respond-to ('small') {\n        margin-left: -65px !important;\n        width: 265px;\n        }\n    }\n}\n\n.notifications-heading {\n    font-size: 32px;\n    @media(max-width: 1024px) {\n        font-size: 27px;\n    }\n}\n\n.notifications-label {\n    width: 100%;\n}\n\n#notification-email-label {\n    margin-bottom: 15px;\n    margin-left: 5px;\n    @include respond-to('small'){\n        margin-left: -60px;  \n    }\n}\n#notification-text-label {\n    margin-left: 5px;\n    @include respond-to('small'){\n        margin-left: -60px;  \n    }\n}\n\n@media only screen and (min-width:1024px) and (max-width: 1220px){\n    .tab-nav{\n      .app-tab{\n        .list{\n          a{\n            font-size:1.5rem;\n          }\n        }\n      }\n    }\n}\n@media only screen and (min-width:1221px) and (max-width: 1250px){\n  .tab-nav{\n    .app-tab{\n      .list{\n        a{\n          font-size:1.8rem;\n        }\n      }\n    }\n  }\n}\n@media only screen and (min-width:1251px) and (max-width: 1273px){\n  .tab-nav{\n    .app-tab{\n      .list{\n        a{\n          font-size:1.9rem;\n        }\n      }\n    }\n  }\n}\n  \n.page-count{\n}\n\n.accounts-tab {\n    margin: 0 10%;\n    .pull-right {\n        @include respond-to('small'){\n        float: right;\n        width: 280px ;\n        margin-right: -60px ;\n        }\n        @media screen and (min-device-width : 375px) and (max-device-width : 667px) {\n         margin-right: -60px;\n       }\n       @media screen and (min-device-width : 414px) and (max-device-width : 736px) {\n        margin-right: -30px;\n      }\n    }\n    .btn-link {\n        padding-top: 10px;\n        @include respond-to('small'){\n          margin-right: 60px;\n        }\n    }\n    .text-right {\n        @include respond-to('small'){\n        text-align: center;\n        }\n    }\n  // @media only screen and (max-width: 1280px) {\n  //   margin: 0 18%;\n  // }\n  \n  // @media only screen and (min-width: 1281px) and (max-width: 1366px) {\n  //   margin: 0 20%;\n  // }\n//   .acc-content {\n//       margin-bottom: 30px;\n//   }\nh2{\n    @include respond-to (small){\n        margin-left: -75px;\n      }  \n}\np{\n    @include respond-to (small){\n    margin-left: -75px ;\n    width: 320px;\n    }\n}\n.main-wrapper{\n    @include respond-to (small){\n        margin-left: -40px !important;\n        } \n}\n\n  h3 {\n    font: 24px 'Omnes-ATT-W02';\n    margin-top: 30px;\n    margin-bottom: 30px;\n    @include respond-to (small){\n      font: 16px 'Omnes-ATT-W02-Medium';\n    }\n  }\n  .icon-arrows-sort-arrow{\n        font-size: 17px !important;\n    }\n    .search {\n        position: relative;\n        input {\n            padding-right: 40px;\n        }\n        .search-icon {\n            cursor: pointer;\n            margin-top: -10px;\n            position: absolute;\n            right: 20px;\n            top: 50%;\n            .icon-controls-magnifyingglass {\n                color: color(default, darker);\n                font-size: 25px;\n                font-weight: bold;\n                margin-right: 3px;\n                margin-top: -2px;\n            }\n            .icon-close {\n                color: color(default, darker);\n                font-size: 25px;\n                font-weight: bold;\n                margin-right: 3px;\n                margin-top: -2px;\n              }\n        }\n    #searchField::-ms-clear{\n      display:none;\n    }\n    }\n\n  .search-label{\n    display: none;\n  }\n\n    .rowdisabled {\n        pointer-events: none;\n    }\n    .box-outer {\n        padding: 0 30px;\n    }\n    .tab-content {\n        padding: 0;\n        h2 {\n            font-size: 3rem;\n            font-weight: normal;\n            margin: 30px 0;\n        }\n        p {\n            margin-bottom: 20px;\n        }\n    }\n    .acc-content {\n        table {\n            margin: 0;\n            tbody:last-child td {\n                border-bottom: 0 !important;\n            }\n        }\n    }\n    tr {\n        th {\n            &:first-child {\n                width: 15%;\n            }\n        }\n    }\n    .accounts {\n        margin-bottom: 30px;\n    }\n    .buttons-section {\n        //margin-top: 20px;\n        //border-top: 1px solid color(default, dark);\n        padding: 30px 0;\n    }\n    .check {\n        margin-bottom: 30px;\n        .checkbox {\n            display: block;\n        }\n    }\n    .error-text {\n        color: color(danger, base);\n        .skin {\n            border: 1px solid color(danger, base);\n        }\n    }\n    .modal-header {\n        margin-bottom: 10px;\n    }\n    .terms-and-conditions {\n        .checkbox {\n            a {\n                color: color(inverse, darker)\n            }\n        }\n        .row {\n            margin-left: 0;\n            margin-right: 0;\n        }\n        .form-group {\n            margin-left: 0;\n            margin-right: 0;\n        }\n        .terms {\n            h1 {\n                margin-top: 30px;\n            }\n        }\n    }\n    .agreement {\n        //border-top: 1px solid color(default, dark);\n        margin-top: 15px; // padding: 30px 0 20px;\n        h2{\n            font-size: 20px;\n          }\n          .attTerms{\n            padding-bottom:10px;\n          }\n        //   .awaitAttTerms{\n        //     color: #5a5a5a;\n        //   }\n        p {\n            margin-bottom: 0;\n            display:inline;\n        }\n        .termsServiceText{\n            p {\n                margin-bottom: 0;\n                display:inline;\n            }\n        }\n    }\n    .signupwithnotab {\n        .agreement {\n            border-top: 1px solid color(default, dark);\n            margin-top: 30px;\n            h3 {\n                margin-bottom: 20px;\n            }\n        }\n    }\n    .signuptabcontainer {\n        position: relative;\n        .pagination {\n            &::after {\n                border: 0 none;\n                height: 0;\n                width: 0;\n            }\n        }\n    }\n    .alert {\n        margin-bottom: 30px;\n    }\n    .fan-profile {\n        cursor: pointer;\n    }\n    .terms-of-service-container {\n        border-top: 1px solid #d2d2d2;\n        .checkbox {\n            &:first-child {\n                margin-bottom: 20px;\n            }\n        }\n    }\n    .ineligible-fans {\n        color: color(danger, base);\n    }\n    .attTerms,\n    .ibmTerms {\n        margin-bottom: 20px;\n        font-size: 16px;\n        font-family: Omnes-ATT-W02,Arial;\n    }\n    @include respond-to (small) {\n        margin: 0 80px;\n\n    .accordion {\n        margin-bottom: 30px;\n    }\n   .tab-nav{\n     width:unset;\n    }\n    .signup-section{\n      .tabContainer{\n        height:max-content;\n      }\n    }\n   \n        .btn-cancel {\n            //margin: 20px 0;\n            text-align: center;\n            //width: 100%;\n            @include respond-to('small'){\n                margin-left: 25px !important;\n            }\n\n        }\n        .btn {\n            text-align: center;\n           // width: 100%;\n            @include respond-to('small'){\n                //width: 325px;\n                //margin-right: 90px;\n            }\n        }\n        .tab-nav {\n            .app-tab {\n                .list>a {\n                    padding: 25px 1px !important;\n                    color: #191919 !important;\n                }\n            }\n        }\n        .tab-content {\n            h2,\n            p {\n                margin-bottom: 20px !important;\n            }\n        }\n        .accounts,\n        .check {\n            margin-bottom: 20px;\n        }\n        .form-group {\n            margin-bottom: 20px;\n        }\n        .agreement {\n            p {\n                margin-bottom: 0 !important;\n            }\n        }\n        .grid-table {\n            margin-left: -15px;\n            margin-right: -15px;\n            @include respond-to(small){\n            margin-left: -100px;\n            margin-right: -39px;\n            }\n        }\n        .step-indicator,\n        .alert {\n            margin-bottom: 30px !important;\n        }\n    }\n    .search-field{\n        float: right;\n      }\n    \n    .link-to-brief {\n        margin: 20px 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
